module.exports = __webpack_public_path__ + "static/media/defaultProjectImage.948fe009.png";